module.exports = __webpack_public_path__ + "img/character-13.0f00febc.svg";